import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography, Tooltip } from "@mui/material";
import CustomTable from "../../components/library/CustomTable/Index";
import CustomSearchBar from "../../components/library/CustomSearchBar";
import CutomConfirmationModel from "../../components/library/CutomConfirmationModel";
import { getDeletedUsers, activeUser } from "./api";
import { toast } from "react-toastify";
import Loader from "../../components/loader";

export default function DeletedUsers() {
  const [rows, setRows] = useState();
  const [filteredRows, setFilteredRows] = useState("");
  const [getSelectedUserEmail, setGetSelectedUserEmail] = useState("");
  const [isUserActive, setisUserActive] = useState();
  const columns = ["First Name", "Last Name", "Email", "Role", "Actions"];
  const [loading, setloading] = useState(false);
  const [isSearch, setIsSearch] = useState(0);
  const [searchVal, setSearchVal] = useState("");

  const [openConfirmationModel, setOpenConfirmationModel] =
    React.useState(false);

  const getUsers = async () => {
    setSearchVal("");
    let response = await getDeletedUsers(setloading);
    let data = response?.data?.map((item) => {
      return {
        name: item?.firstName,
        lastname: item?.lastName,
        email: item?.email,
        role: item?.role,
        actions: (
          <Box>
            <Tooltip title="Active User" arrow>
              <Button
                size="large"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  setOpenConfirmationModel(true);
                  setGetSelectedUserEmail({ email: item?.email });
                }}
              >
                Active
              </Button>
            </Tooltip>
          </Box>
        ),
      };
    });
    setRows(data);
    setFilteredRows(data);
  };

  useEffect(() => {
    getUsers();
  }, []);

  useEffect(() => {
    if (isUserActive) {
      setOpenConfirmationModel(false);
      setisUserActive(false);
      if (getSelectedUserEmail) {
        try {
          activeUserFunc(getSelectedUserEmail);
        } catch (error) {
          toast.error(error.message || "Something went wrong!");
        }
      }
    }
  }, [isUserActive]);

  const activeUserFunc = async (email) => {
    let response = await activeUser(setloading, email);
    toast.success(response.message || "User activated successfully!");
    await getUsers();
  };

  return (
    <div>
      {loading && <Loader />}

      <CutomConfirmationModel
        open={openConfirmationModel}
        setOpen={setOpenConfirmationModel}
        title={"Active Confirmation"}
        messege={
          <Typography>
            Are you sure you want to active
            <span style={{ color: "red" }}>
              {" "}
              {getSelectedUserEmail?.email}{" "}
            </span>
            ?
          </Typography>
        }
        setisAction={setisUserActive}
      />

      <Grid container gap={2} justifyContent={"space-between"}>
        <Grid item md={1.3} xs={12} sm={12} />
        <Grid item md={1.5} xs={12} sm={12} />
        <Grid item md={3} xs={12} sm={12} lg={3} xl={2}>
          <CustomSearchBar
            rows={rows}
            setFilteredRows={setFilteredRows}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <CustomTable
          rows={filteredRows}
          columns={columns}
          isSearch={isSearch}
        />
      </Box>
    </div>
  );
}
